<template>
  <div class="dashboard-chart">
    <div v-if="!loading" class="dashboard-chart-content">
      <dashboard-bar-chart v-if="data.length" :data="data" :y-ticks="yTicks" />
      <div v-else class="kudos-list-empty">
        <div>
          <kudos-empty />
        </div>
        <div class="mt-3">
          No kudos received… yet!
        </div>
      </div>
    </div>
    <div v-else class="text-center p-5">
      <b-spinner variant="primary" label="Loading..." />
    </div>
  </div>
</template>

<script>
import DashboardBarChart from './DashboardBarChart'
import KudosEmpty from '@/assets/images/kudos-empty.svg'

export default {
  name: 'Expertise',

  props: {
    loading: {
      type: Boolean,
      default: false
    },

    data: {
      type: Array,
      default: () => ([])
      // Example: [{ label: 'Project management', value: 50 }]
    }
  },

  data() {
    return {
      yTicks: [
        { value: 0, label: 'On the way' },
        { value: 10, label: 'Great progress' },
        { value: 20, label: 'Advanced' },
        { value: 30, label: 'Proficient' }
      ]
    }
  },

  components: {
    DashboardBarChart,
    KudosEmpty
  }
}
</script>
